import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import colors from "app/colors";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    _hover: {
      borderColor: colors.blue,
      opacity: 0.8,
    },
    _checked: {
      bg: colors.blue,
      borderColor: colors.blue,
      opacity: 1,
      _hover: {
        bg: colors.blue,
      },
    },
    _indeterminate: {
      bg: colors.blue,
      borderColor: colors.blue,
      _hover: {
        bg: colors.blue,
      },
    },
  },
});

export const checkboxTheme = defineMultiStyleConfig({ baseStyle });
